export default __webpack_public_path__ + "static/media/3rd-party-home-Background.6e6fbed3.png";